import { useEditorFile } from "../../../../../hooks";
import PageBreak from "./PageBreak";
import ElementInPage from "./ElementInPage";
import * as Constants from "../../../../../utils/constants";

export default function DxmlPage({ editorPage, isLastPage }) {
    const { getChildItemsToShow, getKeyById } = useEditorFile();
    const elementsToShow = getChildItemsToShow(editorPage);

    const elementClassnNames = (element, index) => {
        const spaceY = "tw-mb-3";
        if (index === (elementsToShow.length - 1))
            return "";

        if (element.Type !== Constants.editorType.table)
            return spaceY;

        if (elementsToShow[index + 1].Type === Constants.editorType.table)
            return "";

        return spaceY;
    }

    return (
        <div>
            {elementsToShow.map((element, index) => (
                <div
                    key={getKeyById(element)}
                    className={elementClassnNames(element, index)}
                >
                    <ElementInPage
                        editorBaseModel={element}
                        elementsInPage={elementsToShow}
                        index={index}
                    />
                </div>
            ))}
            <PageBreak editorPage={editorPage} isLastPage={isLastPage} />
        </div>
    )
}